
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload } from '@/components';
import { useProgressLevelAdd } from '@/modules/progress/level/model/add';
import { progressLevelTypeOption, ProgressLevelType } from '@/modules/progress/level/model/mixins';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.LEVEL.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload },
    setup() {
        const { model, v$, create, linkableItemOption, fetch } = useProgressLevelAdd();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, create, linkableItemOption, progressLevelTypeOption, ProgressLevelType };
    }
});
